var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "tongxin-date-selector"
  }, [_c('h1', {
    staticClass: "title-with-underline"
  }, [_vm._v("請選擇日期")]), _c('div', {
    staticClass: "s-mb-3"
  }, [_vm._v(" 請選擇日期："), _vm.date ? _c('span', [_vm._v("已選擇 " + _vm._s(_vm.selectedDateInString))]) : _vm._e()]), _c('div', {
    staticClass: "tongxin-date-selector__date s-mb-4"
  }, [_c('Datepicker', {
    attrs: {
      "placeholder": "請輸入查詢開始時間",
      "format": "yyyy/MM/dd",
      "language": _vm.zh,
      "disabled-dates": {
        customPredictor: _vm.dateIsUnavailable
      },
      "calendar-class": "datepicker-calendar",
      "wrapper-class": "datepicker-wrapper",
      "bootstrap-styling": "",
      "inline": ""
    },
    model: {
      value: _vm.date,
      callback: function callback($$v) {
        _vm.date = $$v;
      },
      expression: "date"
    }
  })], 1), _vm.notes ? _c('div', {
    staticClass: "tongxin-date-selector__notice"
  }, [_c('div', {
    staticClass: "tongxin-date-selector__notice-divider"
  }), _c('div', {
    staticClass: "s-mb-3 s-font-medium s-pt-3"
  }, [_vm._v("注意事項")]), _c('div', {
    staticClass: "s-text-sm s-text-gray",
    domProps: {
      "innerHTML": _vm._s(_vm.notes)
    }
  })]) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }